import { Typography } from '@mui/material';

import { ConnectedSelect } from '@libs/ui/components/form/select';

import { Qualification } from './types';

const YES_NO_OPTIONS = [
  {
    text: 'Yes',
    value: 'yes',
  },
  {
    text: 'No',
    value: 'no',
  },
];

interface QualificationControlProps {
  qualification: Qualification;
  name: string;
}

export const QualificationControl = ({
  qualification,
  name,
}: QualificationControlProps) => {
  return (
    <ConnectedSelect
      name={name}
      options={YES_NO_OPTIONS}
      label={
        <>
          {qualification.name}
          {qualification.mandatory && (
            <>
              {' '}
              <Typography component="span" color="error">
                *
              </Typography>
            </>
          )}
        </>
      }
      required={qualification.mandatory}
      hideNoneValue={qualification.mandatory}
      fullWidth
      variant="filled"
    />
  );
};
